import { PublicLayout } from "@/components/PublicLayout";
import { useSettings } from "@/lib/settings";
import { mediaUrl } from "@/lib/api";
import { useSeo } from "@/lib/useSeo";
import { FileText, Download, Info, ScrollText, Calculator, FileSpreadsheet, Wrench, Receipt, UserCog, Gauge, Droplets } from "lucide-react";

const sections = [
  {
    icon: ScrollText,
    title: "Gestione ordinaria",
    note: "Prestazioni ordinarie previste dal Codice Civile.",
    rows: [
      { s: "Prestazioni ordinarie previste dal Codice Civile", d: "Tariffa annua", p: "Vedi preventivo" },
    ],
  },
  {
    icon: FileSpreadsheet,
    title: "Altri adempimenti",
    note: "Adempimenti fiscali e amministrativi, contabilizzati in base all'effettiva esecuzione.",
    rows: [
      { s: "Redazione e presentazione del modello 770", d: "Per condominio", p: "Vedi preventivo" },
      { s: "Redazione e presentazione del quadro AC", d: "Per condominio", p: "Vedi preventivo" },
      { s: "Versamento ritenuta d'acconto", d: "Per ogni fattura", p: "€ 6,00" },
      { s: "Certificato annuale delle ritenute d'acconto versate (CU)", d: "Per singolo fornitore", p: "€ 30,00" },
      { s: "Servizio e gestione della fatturazione elettronica", d: "Per condominio", p: "€ 80,00" },
      { s: "Gestione privacy e tenuta registro anagrafe condominiale", d: "Per unità immobiliare / anno", p: "€ 3,00" },
    ],
  },
  {
    icon: Wrench,
    title: "Attività straordinarie",
    rows: [
      { s: "Assemblea straordinaria convocata entro le ore 19:00", d: "Convocazione ed invio verbale — esclusa locazione sala", p: "€ 110,00" },
      { s: "Assemblea straordinaria convocata oltre le ore 19:00", d: "Convocazione ed invio verbale — esclusa locazione sala", p: "€ 135,00" },
      { s: "Pratiche di sgravio fiscale", d: "Per singolo condòmino — quota detrazione annua > € 50,00", p: "€ 35,00" },
      { s: "Pratiche di sgravio fiscale", d: "Per singolo condòmino — quota detrazione annua < € 50,00", p: "€ 12,00" },
      { s: "Gestione fondo speciale per manutenzione straordinaria", d: "Per unità immobiliare / anno", p: "€ 30,00" },
      { s: "Gestione straordinaria (importo lavori superiore a € 1.000,00)", d: "Importo lavori fino a € 10.000,00", p: "€ 200,00" },
      { s: "Gestione straordinaria", d: "Importo lavori da € 10.000,00 a € 25.000,00", p: "€ 550,00" },
      { s: "Gestione straordinaria", d: "Importo lavori superiore a € 25.000,00", p: "3,00%" },
      { s: "Consultazione con avvocati, tecnici, PA ecc.", d: "Compenso orario", p: "€ 42,00" },
      { s: "Risoluzione vertenze fra condòmini, ricerca guasti, sopralluoghi e supervisione sinistri", d: "Compenso orario", p: "€ 35,00" },
      { s: "Denuncia sinistro e gestione del rimborso assicurativo", d: "Per singola pratica", p: "€ 90,00" },
      { s: "Stima del danno e richiesta risarcimento", d: "Importi stimati fino a € 3.000,00", p: "€ 150,00" },
      { s: "Stima del danno e richiesta risarcimento", d: "Importi stimati da € 3.000,00 a € 10.000,00", p: "7,00%" },
      { s: "Stima del danno e richiesta risarcimento", d: "Importi stimati superiori a € 10.000,00", p: "5,00%" },
    ],
  },
  {
    icon: Receipt,
    title: "Rimborso spese accessorie",
    rows: [
      { s: "Rimborso spese postali e accessorie", d: "Solo spese documentate", p: "Vedi ricevuta" },
      { s: "Rimborso spese generali forfettarie (telefoniche, cancelleria, fotocopie)", d: "Per unità immobiliare / anno", p: "€ 8,00" },
      { s: "Rimborso spese per il nolo della sala assembleare", d: "Esclusa quella messa a disposizione dall'ufficio", p: "Vedi ricevuta" },
    ],
  },
  {
    icon: UserCog,
    title: "Pratiche personali",
    rows: [
      { s: "Sollecito bonario telefonico per morosità", d: "Primo sollecito", p: "€ 15,00" },
      { s: "Sollecito bonario scritto per morosità", d: "Secondo sollecito — email o posta ordinaria", p: "€ 25,00" },
      { s: "Ultimo sollecito scritto per morosità", d: "Terzo sollecito — PEC o raccomandata A.R.", p: "€ 35,00" },
      { s: "Pratica di messa in mora tramite avvocato", d: "Al netto della parcella del legale", p: "€ 70,00" },
      { s: "Preparazione documentazione per richiesta di Decreto Ingiuntivo", d: "Al netto della parcella del legale", p: "€ 130,00" },
      { s: "Suddivisione spese tra proprietario ed inquilino", d: "", p: "€ 35,00" },
      { s: "Gestione pagamenti suddivisi tra proprietario ed inquilino", d: "", p: "€ 45,00" },
      { s: "Lettere di richiamo nei confronti di proprietari e inquilini", d: "", p: "€ 60,00" },
      { s: "Fotocopie (a richiesta) di documenti condominiali", d: "Formato A4 a facciata", p: "€ 0,30" },
      { s: "Altre prestazioni valutabili in base al tempo impiegato", d: "Per ora o frazione di ora superiore a 15 min", p: "€ 45,00" },
      { s: "Dichiarazione per vendita", d: "", p: "€ 35,00" },
    ],
  },
  {
    icon: Gauge,
    title: "Contabilizzazioni",
    rows: [
      { s: "Lettura e contabilizzazione consumi idrici (semplice)", d: "Per unità immobiliare / una lettura annuale", p: "€ 8,00" },
      { s: "Lettura e contabilizzazione del calore", d: "Per ripartitore / due letture stagionali (intermedia e finale)", p: "€ 4,50" },
    ],
  },
  {
    icon: Droplets,
    title: "Esercizi ausiliari",
    rows: [
      { s: "Esercizio ausiliare per ripartizione consumi riscaldamento", d: "Per unità immobiliare / anno", p: "€ 18,00" },
      { s: "Esercizio ausiliare per ripartizione consumi acqua calda", d: "Per unità immobiliare / anno", p: "€ 7,00" },
    ],
  },
];

export default function Tariffario() {
  const s = useSettings();
  useSeo({
    title: "Tariffario dei Servizi Condominiali 2026 | Edilstudio Scandicci e Firenze",
    description: "Il tariffario trasparente dei servizi di amministrazione condominiale di Edilstudio a Scandicci e Firenze: gestione ordinaria, adempimenti fiscali, attività straordinarie e costi accessori.",
    canonicalPath: "/tariffario-condominio",
  });

  return (
    <PublicLayout>
      {/* HERO */}
      <section className="bg-[#1B2A41] text-white" data-testid="tariffario-hero">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-16 lg:py-20">
          <p className="eyebrow text-[#F5A623]">Amministrazioni condominiali</p>
          <h1 className="font-display text-4xl lg:text-5xl font-bold mt-3 leading-tight">Tariffario dei servizi 2026</h1>
          <p className="text-white/80 mt-5 leading-relaxed max-w-2xl">
            Crediamo nella trasparenza: ogni servizio ha un costo chiaro e definito. Qui trovi il tariffario in vigore dalla nuova gestione annuale, così sai sempre cosa è incluso e cosa viene conteggiato solo in base all'effettivo utilizzo.
          </p>
          {s.tariffario_url && (
            <a href={mediaUrl(s.tariffario_url)} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-7 bg-white text-[#1B2A41] font-bold px-6 py-3 rounded-full hover:bg-white/90 transition-colors" data-testid="tariffario-pdf-download">
              <Download className="w-5 h-5" /> Scarica il PDF ufficiale
            </a>
          )}
        </div>
      </section>

      {/* INTRO NOTE */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pt-10">
        <div className="flex items-start gap-3 bg-[#EEF4F9] border border-[#DCE6EF] rounded-2xl p-5" data-testid="tariffario-intro-note">
          <Info className="w-5 h-5 text-[#2472C8] mt-0.5 shrink-0" />
          <p className="text-sm text-[#43526A] leading-relaxed">
            Il <strong>compenso di gestione ordinaria</strong> è concordato in preventivo (indicativamente <strong>tra € 80 e € 110 per unità immobiliare l'anno</strong>). Accanto a questo, una serie di attività — come adempimenti fiscali, dichiarazioni, solleciti e pratiche personali — sono <strong>contabilizzate a misura, solo in base all'effettiva esecuzione</strong>. Tutti gli importi sono al netto dell'IVA di legge.
          </p>
        </div>
      </section>

      {/* SECTIONS */}
      <section className="max-w-5xl mx-auto px-4 sm:px-6 py-10 lg:py-14 space-y-8">
        {sections.map((sec, i) => (
          <div key={i} className="bg-white rounded-2xl border border-[#DCE6EF] overflow-hidden" data-testid={`tariffario-section-${i}`}>
            <div className="flex items-center gap-3 px-6 py-4 bg-[#F6F9FC] border-b border-[#DCE6EF]">
              <div className="w-10 h-10 rounded-xl bg-white border border-[#DCE6EF] flex items-center justify-center shrink-0"><sec.icon className="w-5 h-5 text-[#2472C8]" /></div>
              <div>
                <h2 className="font-heading font-bold text-[#1B2A41] text-lg leading-tight">{sec.title}</h2>
                {sec.note && <p className="text-xs text-[#8695A6] mt-0.5">{sec.note}</p>}
              </div>
            </div>
            <ul className="divide-y divide-[#EEF2F7]">
              {sec.rows.map((r, j) => (
                <li key={j} className="flex items-start justify-between gap-4 px-6 py-4">
                  <div className="min-w-0">
                    <p className="text-[#1B2A41] font-medium text-[15px] leading-snug">{r.s}</p>
                    {r.d && <p className="text-[13px] text-[#8695A6] mt-0.5">{r.d}</p>}
                  </div>
                  <span className="shrink-0 font-mono font-semibold text-[#2472C8] text-[15px] whitespace-nowrap bg-[#EEF4F9] rounded-lg px-3 py-1">{r.p}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <p className="text-xs text-[#8695A6] leading-relaxed" data-testid="tariffario-legend">
          Importi unitari soggetti a variazione ISTAT annuale, arrotondati per eccesso ogni € 0,50. Tutti gli importi sono al netto dell'IVA nella misura di legge. In caso di discordanza fa fede il PDF ufficiale scaricabile in alto.
        </p>

        <div className="bg-gradient-to-r from-[#1B2A41] to-[#22406A] text-white rounded-2xl p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5" data-testid="tariffario-cta">
          <div>
            <h2 className="font-display text-2xl font-bold">Vuoi un preventivo su misura per il tuo condominio?</h2>
            <p className="text-white/75 mt-2">Ti prepariamo un'offerta chiara e trasparente, senza costi nascosti.</p>
          </div>
          <a href="/preventivo-condominio" className="inline-flex items-center gap-2 bg-[#F5A623] hover:bg-[#E0961C] text-[#1B2A41] font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap">
            <FileText className="w-5 h-5" /> Richiedi il preventivo
          </a>
        </div>
      </section>
    </PublicLayout>
  );
}
